import React from 'react';
import { SocialFallbackStep as SocialFallbackStepCore } from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';

export const SocialFallbackStep = () => {
    const { goToStep } = useStepsContext();

    return (
        <SocialFallbackStepCore
            onInitialStep={() => goToStep('initial')}
            onProfileSetupStep={() => goToStep('profile_setup')}
            onSocialFallbackStep={() => goToStep('social_fallback')}
        />
    );
};
